import { SGWTConnectCore } from './SGWTConnectCore';

/**
 * Alternative implementation of SGWTConnectCore.
 *
 * This class should only be instantiated and used
 * when the user is on redirect_uri or in an iframe.
 * See explanation in setupSGWTConnect.ts
 */
export class SGWTConnectNoop extends SGWTConnectCore {
  /**
   * Noop.
   */
  public requestAuthorization(): this {
    return this;
  }

  /**
   * Noop.
   */
  public discardAuthorization(): this {
    return this;
  }

  /**
   * Noop.
   */
  public renewAuthorization(): this {
    return this;
  }

  /**
   * Noop.
   */
  public isAuthorized(): boolean {
    return false;
  }

  /**
   * Noop.
   */
  public getAuthorizationError(): null {
    return null;
  }

  /**
   * Noop.
   */
  public getAuthorizationHeader(): null {
    return null;
  }

  /**
   * Noop.
   */
  public getGrantedScope(): null {
    return null;
  }

  /**
   * Noop.
   */
  public hasGrantedScope(): boolean {
    return false;
  }

  /**
   * Noop.
   */
  public getIdToken(): null {
    return null;
  }

  /**
   * Noop.
   */
  public getIdTokenClaims(): null {
    return null;
  }

  /**
   * Noop.
   */
  public enablePeriodicalRenewal(): this {
    return this;
  }

  /**
   * Noop.
   */
  public disablePeriodicalRenewal(): this {
    return this;
  }
}
